import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './EmiSection.css';
import {
  cardVariants,
  hoverVariants,
  textVariants,
  listItemVariants
} from '../../utility/framerAnimations';

const EmiCardsSection = () => {
    const { t } = useTranslation('homepage');

  return (
    <Container className="emi-cards-section">
      <Row className="justify-content-center">
        <Col lg={12} md={12}>
          <div className="cards-container">
            
            {/* Card 1: How EMI is Calculated */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/calculator.png" 
                  alt="Calculator Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                {t('emi-card-title-1')}
              </motion.h3>
              <motion.div 
                className="card-content"
                variants={textVariants}
              >
                <div className="formula-box">
                  <p className="formula-text">
                    E = P × r × (1 + r)<sup>n</sup> / ((1 + r)<sup>n</sup> - 1)
                  </p>
                  <div className="formula-explanation">
                    <p>{t('emi-card-formula-where')}</p>
                    <ul>
                      <li>{t('emi-card-formula-item-1')}</li>
                      <li>{t('emi-card-formula-item-2')}</li>
                      <li>{t('emi-card-formula-item-3')}</li>
                      <li>{t('emi-card-formula-item-4')}</li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            </motion.div>

            {/* Card 2: Why Choose Us? */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/building.png" 
                  alt="Building Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                {t('emi-card-title-2')}
              </motion.h3>
              <motion.ul 
                className="card-list"
                variants={textVariants}
              >
                <motion.li variants={listItemVariants}>
                  {t('emi-card-why-choose-item-1')}
                </motion.li>
                <motion.li variants={listItemVariants}>
                  {t('emi-card-why-choose-item-2')}
                </motion.li>
                <motion.li variants={listItemVariants}>
                  {t('emi-card-why-choose-item-3')}
                </motion.li>
              </motion.ul>
            </motion.div>

            {/* Card 3: Tips for Lower EMI */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/ai-innovation.png" 
                  alt="Lightbulb Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                {t('emi-card-title-3')}
              </motion.h3>
              <motion.ul 
                className="card-list"
                variants={textVariants}
              >
                <motion.li variants={listItemVariants}>
                  {t('emi-card-tips-item-1')}
                </motion.li>
                <motion.li variants={listItemVariants}>
                  {t('emi-card-tips-item-2')}
                </motion.li>
                <motion.li variants={listItemVariants}>
                  {t('emi-card-tips-item-3')}
                </motion.li>
              </motion.ul>
            </motion.div>

            {/* Card 4: Frequently Asked Questions */}
            <motion.div 
              className="emi-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              whileHover="hover"
              hoverVariants={hoverVariants}
            >
              <div className="card-icon">
                <img 
                  src="/images/help-circle.png" 
                  alt="Question Icon"
                  className="custom-icon"
                />
              </div>
              <motion.h3 
                className="card-title"
                variants={textVariants}
              >
                {t('emi-card-title-4')}
              </motion.h3>
              <motion.div 
                className="faq-content"
                variants={textVariants}
              >
                <div className="faq-item">
                  <h4 className="faq-question">{t('emi-card-faq-question-1')}</h4>
                  <p className="faq-answer">{t('emi-card-faq-answer-1')}</p>
                </div>
                <div className="faq-item">
                  <h4 className="faq-question">{t('emi-card-faq-question-2')}</h4>
                  <p className="faq-answer">{t('emi-card-faq-answer-2')}</p>
                </div>
              </motion.div>
            </motion.div>

          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default EmiCardsSection; 